<div class="loading-screen-wrapper" *ngIf="loading">
  <div class="loading-screen-card" role="status" aria-live="polite">
    <div class="spinner-border loading-screen-spinner" aria-hidden="true"></div>
    <span>Cargando...</span>
  </div>
</div>
